import * as React from 'react';
import Chip from '@mui/material/Chip';
import { useNavigate } from 'react-router-dom'
import { Plan } from '../../atom/atom';
import { useRecoilValue, useSetRecoilState } from 'recoil';


export default function PlanButton(props) {
    const setPlan = useSetRecoilState(Plan)
    let history = useNavigate();

    function handleClick(e) {
        setPlan(props.id)
        localStorage.setItem('plan', props.id)
        history('/map')
    }

    return (
        <Chip
            label="Load"
            onClick={(e) => { handleClick(e) }}
        />
    )
}